/** @jsxImportSource @emotion/react */
import React, { useEffect, useState, useContext } from 'react'
import { Box, Button, Grid, Typography, useTheme,Dialog, DialogTitle, DialogContent } from "@mui/material";
import RecordIcon from '@mui/icons-material/Videocam';
import PermissionIcon from '@mui/icons-material/VideocamOff';
import PauseIcon from '@mui/icons-material/Pause';
import FullScreenLoader from '../../FullScreenLoader';
import { Il8nContext } from '../../../Helper/i18n';
import { insertHyphens } from '../../../Helper/Functions';
import axios from 'axios';
import config from '../../../config';
import CircularProgressWithTimer from '../../CircularLoaderTimer'
import './index.css'

let recordedBlobs, mediaRecorder, gumVideo, recordedVideo;

function RecordVideo({ cancelRecording, uploadVideoProof, recordVideoInstruction, setSnackBar, uploadImageProof, setLoading,setVideoLoader, ...props }) {
  const [state, setState] = useState({ save: false, showPlay: false, recording: false, permission: false,locationPermission:false, showStopRec: false })
  const { save, showPlay, recording, permission, showStopRec,locationPermission } = state;
  const [seconds, setSeconds] = useState(5);
  const [videoDuration, setVideoDuration] = useState(16)
  const [isActive, setIsActive] = useState(false);
  const [startRecord, setStartRecord] = useState(false)
  const [progress, setProgress] = useState(10);
  const localeText = useContext(Il8nContext)
  const [showPhotograph, setShowPhotograph] = useState(false);
  const [timerProgress, setTimerProgress] = useState(0);
  const [timerProgressShow, setTimerProgressShow] = useState(false);
  const [hasVideoAnlysisDone, setHasVideoAnlysisDone] = useState(false)
  const [geoLocationData, setGeoLocationData] = useState({})
  const [forceProceed,setForceProceed] = useState(false)
  const [selectedImage,setSelectedImage ] = useState('')
  const [showFailPopup, setShowFailPopup] = useState({
    "showPopup":false,
    "showPopupMessage":""
})
  // Declare canvas and context variables
  const canvas = document.getElementById('canvas');
  const ctx = canvas ? canvas.getContext('2d') : null;
  const snapshotsContainer = document.getElementById('snapshots');
  const failedMsg = document.getElementById('failedMsg')
  const recordedVideoContainer = document.getElementById('gum');
  const recordedVideoContainer2 = document.getElementById('recorded');
  const selectPicMsg = document.getElementById('selectPicMsg')
  let imgArr = []
  let currentTime = 0;
  let videoTimer = null;
  useEffect(() => {
    let timer = null;
    if (isActive && seconds > 0) {
      timer = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
        setProgress((progress) => progress + 20)
      }, 1000);
    }
    if (seconds == 0) {
      startRecording();
    //   setTimeout(() => {
    //     handleStopButton()
    //   }, 15000)
    }
    return () => {
      clearInterval(timer);
    };
  }, [isActive, seconds]);

   useEffect(() => {
    let timer 
    if(timerProgressShow){
       timer = setInterval(() => {
        setTimerProgress((prevProgress) => (prevProgress <= 0 ? 100 : prevProgress - 0.83));
      }, 1000);
    }
    if(timerProgressShow && timerProgress === 0){
      setTimerProgressShow(false)
      setHasVideoAnlysisDone(true)
      selectProfile()
    }
      return () => {
        clearInterval(timer);
      };
    }, [timerProgressShow]);

  useEffect(() => {
    if(videoDuration === 0) {
     handleStopButton() 
     clearInterval(videoTimer)
    }
  }, [videoDuration])

  const theme = useTheme()
  const classes = {
    video: {
      width: '100%',
      height: '100%',
      borderRadius: 'inherit',
      // transform: 'rotateY(180deg)'
    },
    videoRecord: {
      width: '100%',
      height: '100%',
      borderRadius:'inherit',
      transform: 'rotateY(180deg)'
    },
    marginTop: {
      marginTop: theme.spacing(1),
    },
    recordButton: {
      padding: "10px 20px",
    },
    button: {
      padding: "5px 15px",
      marginRight: theme.spacing(2),
      boxShadow: '0px 6px 8px -6px #f540405c'
    },
    bottomButtonGrid: {
      marginTop: "20px"
    },
    marginButtonTop: {
      marginTop: "15px",
      marginRight: "20px"
    },
    leftIcon: {
      marginRight: theme.spacing(1),
      marginLeft:'24px'
    },
    error: {
      display: 'flex'
    },
    buttonResp: {
      padding: "10px 40px"
    },
    stopButton: {
      textTransform: "none",
      position: "absolute",
      top: 0,
      right: 0,
      color: "#fff"
    },
    videoStartedText: {
      color: "green",
      fontWeight: "bold",
      textAlign: "left",
      // margin: "3px 24px 12px",
      display: "block"
    },
    videoTextWrap: {
      display: "flex",
      justifyContent: "start"
    },
  }

  useEffect(() => {
    setTimeout(() => {
      gumVideo = document.getElementById('gum');
      recordedVideo = document.getElementById('recorded');
    }, 10)
  }, [showPlay, save])

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(success, showError)
    navigator.mediaDevices.getUserMedia(
      constraints
    ).then(
      successCallback,
      errorCallback
    );
  }, [])
  var constraints = {
    audio: true,
    video: {
      facingMode: 'user', // Or 'environment'
      width: { ideal: 640 },   // Request an ideal width of 640 pixels
      height: { ideal: 480 },  // Request an ideal height of 480 pixels
      frameRate: { ideal: 10, max: 15 }
    }
  };

  
  function success(position) {
    let positionData = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
     }
    setGeoLocationData(positionData)
  }
  
  function showError(error) {
    setState({ locationPermission: true })
      switch (error.code) {
          case error.PERMISSION_DENIED:
              console.log("User denied the request for Geolocation.")
              break;
          case error.POSITION_UNAVAILABLE:
              console.log("Geolocation is not supported by your browser.")
              break;
          case error.TIMEOUT:
              console.log("The request to get user location timed out.")
              break;
          case error.UNKNOWN_ERROR:
              console.log("An unknown error occurred.")
              break;
      }
  }


 
   function displaySnaps() {
      snapshotsContainer.style.display ='block'
      selectPicMsg.style.display ='block'
      recordedVideoContainer.style.display = 'none'
      recordedVideoContainer2.style.display = 'none'
    }

    // function rotateBase64Image(base64Image) {
    //    let degrees = directionOfVideoImage?.toLowerCase() === "left" ? 270 : 90
    //   return new Promise((resolve, reject) => {
    //     const img = new Image();

    //     img.onload = () => {
    //       const canvas = document.createElement('canvas');
    //       canvas.width = img.height;
    //       canvas.height = img.width;
    //       const ctx = canvas.getContext('2d');

    //       ctx.translate(canvas.width / 2, canvas.height / 2);
    //       ctx.rotate(degrees * Math.PI / 180);
    //       ctx.drawImage(img, -img.width / 2, -img.height / 2);
    //       ctx.rotate(-degrees * Math.PI / 180);
    //       ctx.translate(-canvas.width / 2, -canvas.height / 2);

    //       const rotatedBase64 = canvas.toDataURL();
    //       resolve(rotatedBase64);
    //     };

    //     img.onerror = (error) => {
    //       reject(error);
    //     };

    //     img.src = base64Image;
    //   });
    // }

    function parseTimestampToSeconds(timestampStr) {
      const parts = timestampStr.split(':');
      if (parts.length < 2 || parts.length > 3) {
        return NaN;
      }

      let hours = 0;
      let minutes = 0;
      let seconds = 0;

      if (parts.length === 3) {
        hours = parseInt(parts[0], 10);
        minutes = parseInt(parts[1], 10);
        seconds = parseFloat(parts[2]);
      } else {
        minutes = parseInt(parts[0], 10);
        seconds = parseFloat(parts[1]);
      }

      if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
        return NaN;
      }

      return (hours * 3600) + (minutes * 60) + seconds;
    }

    async function handleExtract(timestampInput) {
      const timestampStr = timestampInput?.trim();
      if (!timestampStr) {
        setShowFailPopup({ showPopup: true, showPopupMessage: 'Please enter a timestamp.' })
        return;
      }

      const targetTime = parseTimestampToSeconds(timestampStr);

      if (isNaN(targetTime) || targetTime < 0 || targetTime > recordedVideo.duration) {
        setShowFailPopup({ showPopup: true, showPopupMessage: `Invalid timestamp or out of video bounds. Please use HH:MM:SS.ms format (e.g., 00:00:08.283) and ensure it's within 0 and ${recordedVideo.duration.toFixed(2)} seconds.` })
        return;
      }

      try {
        recordedVideo.currentTime = targetTime;
        await new Promise(resolve => {
          const onSeeked = () => {
            recordedVideo.removeEventListener('seeked', onSeeked);
            resolve();
          };
          recordedVideo.addEventListener('seeked', onSeeked);
        });
        canvas.width = recordedVideo.videoWidth;
        canvas.height = recordedVideo.videoHeight;
        const ctx1 = canvas?.getContext('2d');
        ctx1.drawImage(recordedVideo, 0, 0, canvas.width, canvas.height);
        let imageDataUrl = canvas?.toDataURL('image/png');
        // finalImage = imageDataUrl
        // if(directionOfVideoImage?.toLowerCase() != 'straight'){
        //  finalImage = await rotateBase64Image(imageDataUrl,directionOfVideoImage)
        // }
        selectProfile(imageDataUrl)
      } catch (error) {
        console.error('Snapshot extraction error:', error);
      } finally {
        console.error('Snapshot extraction');
      }
    }

    const uploadVideoAnalysis = () => {
      setVideoLoader(true)
      recordedVideo.pause()
      let payload = {
        mimeType: "video/mp4",
        videoBase64: recordedVideo?.src?.split("base64,")[1],   //imgSrc?.split("base64,")[1]
      };
      axios.post(process.env.REACT_APP_AARAMBHAH_URL + config.uploadIPVAnalysis, payload)
        .then(resp => {
            setVideoLoader(false);
            if ((resp?.status === true) || (resp?.isForceProceed === true)) {
              if(resp?.isForceProceed === true){
                snapshotsContainer.style.display ='none'
                selectPicMsg.style.display ='none'
                failedMsg.style.display ='block'
                setShowPhotograph(true)
                setForceProceed(true)
                return
              }
              setHasVideoAnlysisDone(true)
              handleExtract(resp?.frameTimeStamp)
            }
            else if((resp?.status === false) && (resp?.isForceProceed === false)) {
            throw new Error(resp.message || ["An error occurred"]);
          }
        })
        .catch(error => {
          setVideoLoader(false);
          let msg = error?.message?.split('|')
          setShowFailPopup({showPopup:true,showPopupMessage:msg || [localeText.videoStatusFailMsg]})
        })
    };

    const selectProfile = (imgData) => {
        /* let imgSrc = snapshotsContainer?.querySelectorAll('.ticked > img')[0]?.src
        if (!hasVideoAnlysisDone) {
          setSnackBar({ message: 'Your IPV Analysis is Processing. Please Wait.', type: "error", show: true });
          return
        } */
        if (imgData) {
          let imgSrc = imgData?.split("base64,")[1]
          uploadImageProof([imgSrc], 0, "", "", geoLocationData?.latitude, geoLocationData?.longitude, true, "", "", true)
          uploadVideoProof([recordedVideo.src],geoLocationData)
        } else {
          setSnackBar({ message: "Please select at least one photo to proceed", type: "error", show: true });
        }
      
    }

  const successCallback = (stream) => {
    window.stream = stream;
    gumVideo.srcObject = stream;
  }

  const errorCallback = (error) => {
    console.log('navigator.getUserMedia error: ', error);
    setState({ permission: true })
  }

  const toggleRecording = () => {
    setStartRecord(true)
    if (!isActive) {
      setIsActive(true);
    }else{
      setSeconds(5)
      startRecording();
      setTimeout(() => {
        handleStopButton()
      }, 5000)
    }
  }

  const handleStop = (event) => {
    console.log('Recorder stopped: ', event);
  }
  // const captureFrames = () => {
  //   setVideoLoader(true)
  //   if (currentTime >= 15) {
  //        uploadVideoAnalysis(recordedVideo,imgArr) 
  //        //  setImageArray(imgArr)
  //     return;
  //   }

  //   if (currentTime >= 5) {
  //     canvas.width = recordedVideo.videoWidth;
  //     canvas.height = recordedVideo.videoHeight;
  //     ctx.drawImage(recordedVideo, 0, 0, canvas.width, canvas.height);
  //     const wrapperDiv = document.createElement('div');
  //     wrapperDiv.className = 'snapList'
  //     Object.assign(wrapperDiv.style, classes.snapList);
  //     const img = new Image();
  //     img.id = 'CapturedImage_' + (currentTime - 5);
  //     img.src = canvas.toDataURL('image/png');
  //     let imgBase64 = canvas.toDataURL('image/png').split(',')[1]
  //     imgArr.push(imgBase64)
  //     img.onload = function() {
  //       img.onclick = function () {
  //           snapshotsContainer?.querySelectorAll('.ticked').forEach(element => {
  //               element.classList.remove('ticked');
  //           });
  //           wrapperDiv.classList.add('ticked');
  //       };
  //     };
  //     snapshotsContainer.appendChild(wrapperDiv)
  //     wrapperDiv.appendChild(img);
  //   }
  //   currentTime++;
  //   // setTimeout(captureFrames, 1000);
  // };

  const handleDataAvailable = (event) => {
    if (event.data && event.data.size > 0) {
      recordedBlobs.push(event.data);
    }
  }

  const startRecording = () => {
    setState({ recording: true })
    videoTimer = setInterval(() => {
      setVideoDuration((videoDuration) => videoDuration - 1);
    }, 1000);

    var options = { mimeType: 'video/webm;codecs=vp9', videoBitsPerSecond: 1500000 };
    recordedBlobs = [];
    try {
      mediaRecorder = new MediaRecorder(window.stream, options);
    } catch (e0) {
      console.log('Unable to create MediaRecorder with options Object: ', options, e0);
      try {
        options = { mimeType: 'video/webm;codecs=vp8', videoBitsPerSecond: 1500000 };
        mediaRecorder = new MediaRecorder(window.stream, options);
      } catch (e1) {
        console.log('Unable to create MediaRecorder with options Object: ', options, e1);
        try {
          options = 'video/mp4';
          mediaRecorder = new MediaRecorder(window.stream, options);
        } catch (e2) {
          alert(localeText?.uploadMediaRecorder);
          console.error('Exception while creating MediaRecorder:', e2);
          return;
        }
      }
    }
    mediaRecorder.onstop = handleStop;
    mediaRecorder.ondataavailable = handleDataAvailable;
    mediaRecorder.start(10); // collect 10ms of data
    console.log('MediaRecorder started', mediaRecorder);
  }

  const handleStopButton = () => {
    stopRecording();
    setState({
      ...state,
      showPlay: true,
      save: true
    });
  };



  const stopRecording = () => {
    mediaRecorder.stop();
    var superBuffer = new Blob(recordedBlobs, { type: 'video/webm' });
    //recordedVideo.src = window.URL.createObjectURL(superBuffer);
    var reader = new FileReader();
    reader.onload = function () {
      var dataUrl = reader.result;
      var base64 = "data:video/mp4;base64," + dataUrl.split(',')[1];
      recordedVideo.src = base64;
    };
    reader.readAsDataURL(superBuffer);
    recordedVideo.controls = true;
  }
  return (
    <div style={{ display: 'flex',flexDirection: 'column',alignItems: 'center' }}>
      {
        
      (permission && locationPermission) ? <h3 css={classes.error}><PermissionIcon css={classes.leftIcon} />{localeText?.locationCameraAccess}</h3> : permission ? <h3 css={classes.error}><PermissionIcon css={classes.leftIcon} />{localeText?.uploadPermission}</h3> : locationPermission ? <h3 css={classes.error}><PermissionIcon css={classes.leftIcon} />{localeText?.locationAccess}</h3>
          : 
        <>
          {showFailPopup.showPopup && <Dialog
                open={showFailPopup.showPopup}
								maxWidth={"md"}
            >
                {/* <DialogTitle onClose={togglePanFailPopup} /> */}
								<DialogTitle dontShowCloseIcon>
									<Grid container direction={"column"} alignItems={"center"} justifyContent="center">
										<Grid item>
											<Typography variant="h6" css={{ fontWeight: "bold", textAlign: "center",color:"red" }}>{localeText?.IPVFailMessage}</Typography>
										</Grid>
									</Grid>
								</DialogTitle>
                <DialogContent dividers css={{ textAlign: "center", margin: "0px 30px", }}>
									<Grid container direction={"column"} alignItems={"flex-start"} >
                  <ol style={{textAlign:'left', fontSize:'18px'}}>
                      {showFailPopup.showPopupMessage.map((instruction, index) => (
                          <li key={index}>
                                {instruction}
                          </li>
                      ))}
                  </ol>
                    
									</Grid>
									<Grid item display={"flex"} justifyContent={"center"}>
											<Button variant="contained" color="primary" css={{ textTransform: "none", marginTop: "50px",textAlign:"center" }} onClick={cancelRecording}>
												OK
											</Button>
										</Grid>
								</DialogContent>
            </Dialog>}
            {!showPhotograph && !showPlay &&recordVideoInstruction?.uniqueCode &&  (
                <div className='digitCode'>
                  <p><img src="images/speak-aloud.svg" width="25" height="25" /><span>{localeText?.VerifyUniqueCodeText}</span></p>
                  <div className='verificationCode'>{insertHyphens(recordVideoInstruction?.uniqueCode)}</div>
                </div>
            )}
            {
             (showPlay === undefined && !showPhotograph && recording && seconds == 0) &&
              <span css={classes.videoStartedText}>{localeText?.uploadStop} {videoDuration} {localeText?.uploadSeconds}</span>
            }
            <div className='video-container' style={{display: showPhotograph ? 'none' : 'flex '}}>
               <video id="gum" css={recording || startRecord ? classes.videoRecord : classes.video} style={showPlay ? { display: 'none' } : showPhotograph ? {display: 'none'} : {}} autoPlay muted playsInline></video>
               <video id="recorded" autoPlay loop playsInline controls style={showPlay ? {} : { display: 'none' }} css={classes.video}></video>
            </div>
                { timerProgressShow && <div class="timer_div" style={{ display:'flex',justifyContent:'center',alignItems:'center' }}>
                <CircularProgressWithTimer value={timerProgress} size={100} secondsToLoad={0.83} showTimeInMin={true} />
                <div style={{padding:'10px'}}>
                <Typography variant='h6'> Analyzing Video...  </Typography>
                <Typography variant='h6'> This may take a few moments. Please wait. </Typography>
                </div>
                </div>}
                <div id="failedMsg" style={{display:  'none',textAlign:  'center'}}>
                    <img src="/images/noaccess.svg" />
                    {/* <h2>Your online IPV verification failed</h2> */}
                    <h3>You have exceeded the maximum allowed attempts (10) for Video In-Person Verification (IPV)</h3>
                    <h3>Kindly contact KYC Team <a href="mailto: kychelpdesk@tradebulls.in" title=" kychelpdesk@tradebulls.in">(kychelpdesk@tradebulls.in)</a> or Enterprise Support Team <a href="mailto:enterprise.support@tradebulls.in" title="enterprise.support@tradebulls.in">(enterprise.support@tradebulls.in)</a>.</h3>
                  </div>
                <Grid style={{display: 'none',flexDirection:'column'}}>
                <div id="selectPicMsg" style={{ display: "none" }}>
                    <Typography variant={'h3'} class="select-pic-msg">Select one final image to complete</Typography>
                  </div>
                  

                <div id="snapshots" style={{ display: 'none', flexWrap: 'wrap' }}></div>
                  <canvas id="canvas" style={{ display: 'none' }}></canvas>
                </Grid>
            <div style={{textAlign:'center'}}>
              <div css={classes.videoTextWrap}>
                {isActive && seconds > 0 &&
                  <>
                    <FullScreenLoader width="100%" height="100%" loaderImage={false} seconds={seconds} value={progress} />
                  </>
                }
              </div>
              {
                showPhotograph && !forceProceed ?
                <div id="boxDiv">
                {/* <Box display="flex" flexDirection="column" alignItems="flex-start"> 
                  
                  <Button variant={"contained"} color={"primary"} id="doneBtn" style={{float:'left'}} onClick={cancelRecording}>Recapture</Button>
                  <Button variant={"contained"} color={"primary"} id="doneBtn" disabled={!hasVideoAnlysisDone} style={{float:'right'}} onClick={selectProfile}>Done</Button>
                
                </Box> */}
                  <Box display="flex" flexDirection="column" alignItems="flex-start"> 
                      <Typography style={{display: hasVideoAnlysisDone ? "none" : "block"}} variant="body2" color="error">
                          {"Please wait till Video Analysis is done."}
                        </Typography>
                  </Box>
                  <Grid style={{display:'flex'}}>
                    <Grid item css={classes.bottomButtonGrid}>
                      <Button variant={"contained"} color={"primary"} id="doneBtn" style={{float:'left', margin: '0 10px'}} onClick={cancelRecording}>Recapture</Button>
                      </Grid>
                      <Grid item css={classes.bottomButtonGrid}>
                        <Button variant={"contained"} color={"primary"} id="doneBtn" disabled={!hasVideoAnlysisDone} style={{float:'right', margin: '0 10px'}} onClick={selectProfile}>Done</Button>
                      </Grid>
                  </Grid>
                </div>
                
             :
                showPlay && !forceProceed?
                    <Grid style={{display:'flex'}}>
                      <Grid item css={classes.bottomButtonGrid}>
                        <Button css={`${classes.button} ${classes.marginTop}`}  style={{ margin: '0 10px' }} variant={"contained"} color={"primary"} onClick={() => { uploadVideoAnalysis() }}>Upload</Button>
                      </Grid>
                       {/* <Grid item css={classes.bottomButtonGrid}>
                        <Button css={`${classes.button} ${classes.marginTop}`} style={{ margin: '0 10px'  }} variant={"contained"} color={"primary"} onClick={cancelRecording}>Recapture</Button>
                      </Grid> 
                      <Grid item css={classes.bottomButtonGrid}>
                        <Button css={!props.matches ? classes.button : props.buttonResp} variant={"outlined"} color={"primary"} onClick={cancelRecording}>{localeText?.uploadCancel}</Button>
                      </Grid>*/}
                  </Grid>
                  :
                  !forceProceed&& <Button css={`${classes.recordButton} ${classes.marginTop} ${classes.marginButtonTop}`} variant={"contained"} color={"primary"} disabled={recording || (startRecord && seconds != 0)} onClick={() => toggleRecording()}>{!recording ? <RecordIcon css={classes.leftIcon} /> : <PauseIcon css={classes.leftIcon} />}{!recording || (startRecord && seconds != 0) ? localeText?.uploadStartRecording : localeText?.uploadRecord}</Button>
              }
            </div>
          </>
      }
    </div>

  )
}

export default RecordVideo
